


















































import {
  Vue, Component, Prop, Ref,
} from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';

interface ParentComponent {
  userInput: {
    contacts: {
      contacts: string;
      mobileTelephone: string;
      department: string;
      email: string;
      telephone: string;
    }[];
  };
}

@Component
export default class ContactForm extends Vue {
  @Prop(Boolean) readonly isAdd!: boolean;

  @Prop(Number) readonly index!: number;

  @Ref('form') readonly form!: ElForm;

  loading = false;

  visible = false;

  params = {
    contacts: '',
    mobileTelephone: '',
    department: '',
    email: '',
    telephone: '',
  };

  rules = {
    contacts: [{ required: true, trigger: 'blur', message: '请输入联系人名称' }],
  };

  cancel() {
    this.resetForm();
  }

  doSubmit() {
    this.loading = true;
    this.form.validate((valid: boolean) => {
      if (valid) {
        if (!this.params.mobileTelephone && !this.params.telephone) {
          this.$notify({
            title: '信息不完整',
            type: 'error',
            message: '请填写至少一种联系方式（座机或手机）',
          });
          this.loading = false;
        } else if (this.isAdd) {
          this.doAdd();
        } else {
          this.doEdit();
        }
      } else {
        this.loading = false;
      }
    });
  }

  doAdd() {
    (this.$parent as ParentComponent & Vue).userInput.contacts.push({ ...this.params });
    this.resetForm();
    this.$message.success('添加成功');
    this.loading = false;
  }

  doEdit() {
    (this.$parent as ParentComponent & Vue).userInput
      .contacts.splice(this.index, 1, { ...this.params });
    this.resetForm();
    this.$message.success('修改成功');
    this.loading = false;
  }

  resetForm() {
    this.visible = false;
    this.form.resetFields();
    this.params = {
      contacts: '',
      mobileTelephone: '',
      department: '',
      email: '',
      telephone: '',
    };
  }
}
